<template>
  <div :class="['mainHeader',className]">
    <h2 class="logo" :aria-label="headingTitle">
      <router-link to="/" :title="headingTitle">
        <img src="../assets/images/logo.png">
        <img src="../assets/images/logo-text.png">
      </router-link>
    </h2>
    <div class="center-box">
      <router-link to="/">{{ $t('header.text1') }}</router-link>
      <router-link to="/about">{{ $t('header.text2') }}</router-link>
      <router-link to="/games">{{ $t('header.text3') }}</router-link>
    </div>
    <div class="right-box">
      <div class="lang-box">
        <el-select v-model="lang" popper-class="lang-option" :popper-append-to-body="false" class="lang-select" placeholder="" @change="onLangChange">
          <div slot="prefix">
            <img src="../assets/images/language.png" class="icon" alt="Language">
          </div>
          <el-option v-for="item in getOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'HeaderComp',
  components: {},
  data() {
    return {
      langOptions:[
        {label:'English',value:'en'},
        {label:'繁體中文',value:'zh'},
        // {label:'อักษรไทย',value:'th'},
      ],
      lang:'',
      className:'',
      result: {},
      headingTitle: ''
    }
  },
  computed: {
    getOptions(){
      return [
        {label:'English',value:'en'},
        {label:'繁體中文',value:'zh'},
        // {label:'อักษรไทย',value:'th'},
      ]
    },
    getLogo() {
      if(window.innerWidth <= 750) {
        return require('@/assets/images/logo-m.png')
      }
      return require('@/assets/images/logo.png')
    }
  },
  created() {
    window.addEventListener('scroll', () => {
      // 获取当前的滚动位置
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      // 判断是否有滚动
      if (scrollTop > 0) {
        this.className = 'smaller'
      } else {
        this.className = ''
      }
    });
    let lang = localStorage.getItem('lang')
    if(lang){
      this.lang = lang
    }else{
      this.lang = 'en'
    }
  },
  mounted() {
    this.getTitle()
  },
  methods: {
    onLangChange(e){
      localStorage.setItem('lang',e)
      this.$i18n.locale = e
    },
    getTitle() {
      switch(this.$route.path) {
        case '/':
          this.headingTitle = this.$t('meta.h1')
          break
        case '/about':
          this.headingTitle = this.$t('meta.about.h1')
          break
        case '/games':
          this.headingTitle = this.$t('meta.games.h1')
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>@use "@/assets/scss/header.scss";</style>
